import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, Download } from "lucide-react";

const TYPE_COLOR = {
  PDF: "bg-red-50 text-red-700",
  DOCX: "bg-sky-50 text-sky-700",
  XLSX: "bg-emerald-50 text-emerald-700",
  ZIP: "bg-stone-100 text-stone-700",
};

export default function StaffDocuments() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/documents").then(r => setDocs(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="staff-documents" className="space-y-6">
      <div>
        <div className="overline text-[var(--brand-primary)]">Documentos</div>
        <h2 className="font-serif-cg text-3xl md:text-4xl tracking-tight mt-2">Archivos y materiales del evento</h2>
        <p className="text-sm text-[var(--brand-muted)] mt-3 max-w-2xl">
          Centralizamos aquí los documentos clave del comité organizador. Los enlaces se habilitarán conforme los archivos sean cargados.
        </p>
      </div>

      {loading ? (
        <p className="text-[var(--brand-muted)]">Cargando...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {docs.map((d, idx) => (
            <div key={d.id} data-testid={`document-${idx}`} className="card-cg p-5 flex flex-col">
              <div className="flex items-start justify-between gap-3">
                <FileText className="text-[var(--brand-primary)]" />
                <span className={`text-[11px] px-2 py-1 ${TYPE_COLOR[d.type] || "bg-stone-100 text-stone-700"}`}>{d.type}</span>
              </div>
              <h3 className="font-serif-cg text-lg mt-4">{d.title}</h3>
              <p className="text-sm text-[var(--brand-muted)] mt-1 leading-relaxed">{d.description}</p>
              <button
                disabled
                className="mt-auto pt-5 text-xs text-[var(--brand-muted)] flex items-center gap-2 uppercase tracking-wider"
                data-testid={`document-${idx}-download`}
              >
                <Download size={12} /> Próximamente
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
